import { ErrorHandler, Injectable, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FedevAuthService } from '@bmw-fedev/auth';
import { DateTime } from 'luxon';
import { ToastExtendedService } from './toast-extended.service';
import {
  buildReportContext,
  buildRuntimeErrorReport,
} from './http/error-report';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly auth = inject(FedevAuthService);
  private readonly toastExt = inject(ToastExtendedService);

  public handleError(error: unknown): void {
    console.error(error);
    if (error instanceof HttpErrorResponse) {
      return;
    }
    const context = buildReportContext(
      this.auth.currentUser() ?? 'unknown',
      DateTime.now().toISO() ?? ''
    );
    this.toastExt.pushErrorToast({
      id: 'runtime-error',
      tone: 'critical',
      toastText: buildRuntimeErrorReport(error, context),
    });
  }
}
